import { AfterContentInit, AfterViewInit, ApplicationRef, Component, ComponentFactoryResolver, DestroyRef, EmbeddedViewRef, inject, Injector, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { map } from 'rxjs';

import { ImgPreviewComponent } from '../../../../shared/components/img-preview/img-preview.component';
import { BasicFile } from '../../../../shared/models/basic-file.model';
import { SidenavService } from '../../../../shared/services/sidenav.service';
import { UtilityFunctions } from '../../../../shared/utilities/functions.models';

import { GridColumn, GridColumnTypeEnum } from '../../../../models/common/grid-column.models';
import { SidebarTypeEnum } from '../../../../models/common/sidebar-type.enum';
import { TopbarService } from '../../../../shared/services/topbar.service';
import { ColumnInfo } from '../../../../shared/models/column-info.type';
import { FilterService } from '../../../../shared/services/filter.service';

import { Warehouse } from '../../../../models/common/warehouse.model';
import { Photographer } from '../../../../models/common/photographer.models';
import { Category } from '../../../../models/common/category.model';
import { Brand } from '../../../../models/common/brand.model';
import { Ids } from '../../../../models/common/ids.model';

import { GraphQLService } from '../../../../services/graph-ql.service';
import { DatabaseQueries, SharedQueries, PhotographerQueries } from '../../../../models/shared/enums/get-query';
import { WrapperResultGraphQL } from '../../../../models/shared/types/wrapper-result-graphql.type';
import { AppService } from '../../../../app.service';

import { MatDialog } from '@angular/material/dialog';
import { FilterListComponent } from '../../../../shared/components/filter-list/filter-list.component';
import { PhotographerFilterService } from 'src/app/shared/services/filters/photographer-filter.service';
import { FilterDialogData } from '../../../../shared/models/types/filter-dialog-data.type';
import { WarehouseFilterService } from 'src/app/shared/services/filters/warehouse-filter.service';
import { StyleGroupFilterService } from 'src/app/shared/services/filters/style-group-filter.service';
import { StyleDescriptionFilterService } from 'src/app/shared/services/filters/style-description-filter.service';
import { PurposeFilterService } from 'src/app/shared/services/filters/purpose-filter.service';
import { TeamFilterService } from 'src/app/shared/services/filters/team-filter.service';
import { SuggestedSeasonFilterService } from 'src/app/shared/services/filters/suggested-season-filter.service';
import { BrandFilterService } from 'src/app/shared/services/filters/brand-filter.service';
import { CategoryFilterService } from 'src/app/shared/services/filters/category-filter.service';
import { LoaderService } from '../../../../shared/services/loader.service';
import { CollectionFilterService } from 'src/app/shared/services/filters/collection-filter.service';
import { Collection } from 'src/app/shared/models/types/collection.type';
import { MutationQuery } from 'src/app/models/shared/enums/mutation-query.enum';
import { StyleGroup } from '../../models/style-group.type';
import { StyleDescription } from '../../models/style-description.type';
import { Purpose } from '../../models/purpose.type';
import { Team } from '../../models/team.type';
import { SuggestedSeason } from '../../models/suggested-season.type';
import { CompanyStyle, StyleOrdersInfo } from '../../models/company-style.type';

@Component({
	standalone: false,
	selector: 'bt-style',
	templateUrl: './style.component.html',
	styleUrls: ['./style.component.scss']
})
export class StyleComponent implements AfterViewInit, AfterContentInit {
	@ViewChild('menuColumn') menuColumn: any;
	@ViewChild('warehouseColumn') warehouseColumn: any;
	@ViewChild('styleOrderColumn') styleOrderColumn: any;

	readonly #dialog = inject(MatDialog);
	readonly #appService = inject(AppService);
	readonly #graphQLService = inject(GraphQLService);
	readonly #destroyRef = inject(DestroyRef);
	readonly #filterService = inject(FilterService);
	readonly #loaderService = inject(LoaderService);

	readonly #applicationRef = inject(ApplicationRef);
	readonly #injector = inject(Injector);
	readonly #topbarService = inject(TopbarService);
	readonly #sidenavService = inject(SidenavService);
	readonly #activatedRoute = inject(ActivatedRoute);
	readonly #router = inject(Router);
	readonly #componentFactoryResolver = inject(ComponentFactoryResolver);

	// showModal = false;

	// columns: Array<ColumnInfo> = [
	// 	{ title: '', width: '5%', key: 'action' },
	// 	{ title: 'Style', width: '25%', key: 'fullName' },
	// 	{ title: 'Brand', width: '10%', key: 'brandName' },
	// 	{ title: 'Category', width: '15%', key: 'categoryName' },
	// 	{ title: 'Warehouses', width: '30%', key: 'warehouses' },
	// 	{ title: 'Style orders', width: '15%', key: 'ordersInfo' }
	// ];

	// modelId!: number;
	// currentSidebar!: SidebarTypeEnum;
	// sidebarTypeEnum = SidebarTypeEnum;
	database: { data?: Array<CompanyStyle>; pageNumber: number; pageSize: number; search: string; total?: number; notAssigned?: boolean; tmp?: CompanyStyle } = {
		pageNumber: 0,
		pageSize: 50,
		search: ''
	};
	gridColumns!: Array<GridColumn>;
	ordersGridColumns!: Array<GridColumn>;
	warehouseGridColumns!: Array<GridColumn>;
	gridColumnTypeEnum = GridColumnTypeEnum;
	loaderId = UtilityFunctions.newGuid();
	sidebarLoaderId = UtilityFunctions.newGuid();
	customSidebarTitle!: 'Style orders' | 'Style warehouses';

	filtersList = [
		{ id: 'brands', label: 'Brands' },
		{ id: 'categories', label: 'Categories' },
		{ id: 'photographers', label: 'Photographers' },
		// { id: 'warehouses', label: 'Warehouses' },
		{ id: 'styleGroups', label: 'Style Groups' },
		{ id: 'styleDescriptions', label: 'Style Descriptions' },
		{ id: 'collections', label: 'Collections' },
		{ id: 'purposes', label: 'Purposes' },
		{ id: 'teams', label: 'Teams' },
		{ id: 'shopSellingPeriods', label: 'Shop Selling Periods' }
	];

	brands: FilterDialogData<Brand> = {
		title: 'Brands',
		selected: [],
		filterService: inject(BrandFilterService)
	};
	categories: FilterDialogData<Category> = {
		title: 'Categories',
		selected: [],
		filterService: inject(CategoryFilterService),
		variables: { brandIds: [] }
	};
	photographers: FilterDialogData<Photographer> = {
		title: 'Photographers',
		selected: [],
		filterService: inject(PhotographerFilterService),
		variables: { page: 0, size: 50 }
	};
	warehouses: FilterDialogData<Warehouse> = {
		title: 'Warehouses',
		selected: [],
		filterService: inject(WarehouseFilterService)
	};
	styleGroups: FilterDialogData<StyleGroup> = {
		title: 'Style Groups',
		selected: [],
		filterService: inject(StyleGroupFilterService)
	};
	styleDescriptions: FilterDialogData<StyleDescription> = {
		title: 'Style Descriptions',
		selected: [],
		filterService: inject(StyleDescriptionFilterService)
	};
	collections: FilterDialogData<Collection> = {
		title: 'Collections',
		selected: [],
		filterService: inject(CollectionFilterService)
	};
	purposes: FilterDialogData<Purpose> = {
		title: 'Purposes',
		selected: [],
		filterService: inject(PurposeFilterService)
	};
	teams: FilterDialogData<Team> = {
		title: 'Teams',
		selected: [],
		filterService: inject(TeamFilterService)
	};
	shopSellingPeriods: FilterDialogData<SuggestedSeason> = {
		title: 'Shop Selling Periods',
		selected: [],
		filterService: inject(SuggestedSeasonFilterService)
	};

	constructor() {
		this.queryParamsSubscribe();
		this.searchTextSubscription();
		// this.setGridColumns();
	}

	ngAfterViewInit(): void {
		// this.columns = [
		// 	{ title: '', width: '5%', key: 'action', template: this.menuColumn },
		// 	{ title: 'Style', width: '25%', key: 'fullName', template: null },
		// 	{ title: 'Brand', width: '10%', key: 'brandName', template: null },
		// 	{ title: 'Category', width: '15%', key: 'categoryName', template: null },
		// 	{ title: 'Warehouses', width: '25%', key: 'warehouses', template: this.warehouseColumn },
		// 	{ title: 'Style orders', width: '20%', key: 'ordersInfo', template: this.styleOrderColumn }
		// ];
	}

	ngAfterContentInit(): void {
		//Acquisizione dei parametri dell'url
		this.getData();
	}

	openDialogFilter(title: string = ''): void {
		const initialValue = [...this[title].selected];
		const dialog = this.#dialog.open(FilterListComponent<any>, {
			data: { title: this[title].title, selected: this[title].selected, filterService: this[title].filterService, variables: this[title].variables },
			height: '70%',
			width: 'auto',
			minWidth: '25%'
		});

		dialog.afterClosed().subscribe({
			next: (res) => {
				if (res) {
					this.applyFilters(title, res);
					if (title === 'brands') this.categories.variables.brandIds = res.map((el) => el.brandId);
				} else {
					this[title].selected = initialValue;
				}
			}
		});
	}

	getLabel(filter: string): string {
		return this[filter].selected.length
			? `: ${this[filter].selected
					.map((el) => el.displayName)
					.join(', ')
					.slice(0, 20)}`
			: '';
	}

	getFullTitleFilter(filter: string): string {
		return this[filter].selected.length ? `${this[filter].selected.map((el) => el.displayName).join(', ')}` : '';
	}

	clearFilter(event: any, filter: string): void {
		event.stopPropagation();
		this[filter].selected = [];
		(this[filter] as FilterDialogData<any>).filterService.clearSelection();
		this.#filterService.removeDataFromUrl(filter, () => null);
		if (filter === 'brands') this['categories'].variables.brandIds = [];
	}

	getData() {
		const params = this.#filterService.getDataFromUrl();
		this.getParams(params);
	}

	//Prende e assegna i parametri dell'url
	private getParams(params: { [key: string]: string }): void {
		if (params['brands']) {
			//const brandParams = this.parseBrands(params['brands']);
			const ids = params['brands'].split('-').map((el) => +el);
			this.getBrands(ids);
		} else {
			this.brands.selected = [];
		}

		if (params['categories']) {
			const ids = params['categories'].split('-').map((el) => +el);
			this.getCategories(ids);
		} else {
			this.categories.selected = [];
		}

		if (params['photographers']) {
			const ids = params['photographers'].split('-').map((el) => new Ids(+el));
			this.getPhotographers(ids);
		} else {
			this.photographers.selected = [];
		}

		if (params['warehouses']) {
			const ids = params['warehouses'].split('-').map((el) => +el);
			this.getWarehouses(ids);
		} else {
			this.warehouses.selected = [];
		}

		if (params['search']) this.database.search = params['search'];

		if (params['styleGroups']) {
			const ids = params['styleGroups'].split('-').map((el) => +el);
			this.getStyleGroups(ids);
		} else {
			this.styleGroups.selected = [];
		}

		if (params['styleDescriptions']) {
			const ids = params['styleDescriptions'].split('-').map((el) => +el);
			this.getStyleDescriptions(ids);
		} else {
			this.styleDescriptions.selected = [];
		}

		if (params['collections']) {
			const ids = params['collections'].split('-').map((el) => +el);
			this.getCollections(ids);
		} else {
			this.collections.selected = [];
		}

		if (params['teams']) {
			const ids = params['teams'].split('-').map((el) => +el);
			this.getTeams(ids);
		} else {
			this.teams.selected = [];
		}

		if (params['shopSellingPeriods']) {
			const ids = params['shopSellingPeriods'].split('-').map((el) => +el);
			this.getSuggestedSeason(ids);
		} else {
			this.shopSellingPeriods.selected = [];
		}

		if (params['purposes']) {
			const ids = params['purposes'].split('-').map((el) => +el);
			this.getPurposes(ids);
		} else {
			this.purposes.selected = [];
		}
	}

	public onStyleInfo(item: CompanyStyle) {
		// const params: Params = { modelId: item.modelId };
		// this.#sidenavService.newItemUrlPart('styles', params);
		this.#router.navigate(['/company/style-info', item.modelId]);
	}

	// public onExitFromInfo() {
	// 	const params: Params = {};
	// 	this.#sidenavService.newItemUrlPart('styles', params);
	// }

	public onStyleSketch(style: CompanyStyle) {
		if (!!style.sketchImgPath) {
			if (style.sketchImgPath) {
				const componentRef = this.#componentFactoryResolver.resolveComponentFactory(ImgPreviewComponent).create(this.#injector);
				componentRef.instance.file = new BasicFile({
					FileName: style.fullName,
					FilePath: style.sketchImgPath
				});
				componentRef.instance.closed.subscribe(() => {
					this.#applicationRef.detachView(componentRef.hostView);
					componentRef.destroy();
				});
				this.#applicationRef.attachView(componentRef.hostView);
				const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
				document.body.appendChild(domElem);
			}
		}
	}

	public getCompanyStyles(page: number, search?: string, params?: { [key: string]: string }) {
		this.database.pageNumber = page;

		const filters = {
			companyId: this.#appService.companyId,
			paginationPage: this.database.pageNumber ?? 0,
			paginationSize: this.database.pageSize,
			search: search ? search : this.database.search,
			notAssigned: !!this.database.notAssigned,
			brandIds: params && params['brands'] ? params['brands'].split('-').map((el) => new Ids(+el)) : this.brands.selected.map((el) => new Ids(el.displayId)),
			categoryIds:
				params && params['categories']
					? params['categories'].split('-').map((el) => new Ids(+el))
					: this.categories.selected.map((el) => new Ids(el.displayId)),
			photographersIds:
				params && params['photographers']
					? params['photographers'].split('-').map((el) => new Ids(+el))
					: this.photographers.selected.map((el) => new Ids(el.displayId)),
			warehousesIds:
				params && params['warehouses']
					? params['warehouses'].split('-').map((el) => new Ids(+el))
					: this.warehouses.selected.map((el) => new Ids(el.displayId)),
			styleGroupIds:
				params && params['styleGroups']
					? params['styleGroups'].split('-').map((el) => new Ids(+el))
					: this.styleGroups.selected.map((el) => new Ids(el.displayId)),
			styleDescriptionIds:
				params && params['styleDescriptions']
					? params['styleDescriptions'].split('-').map((el) => new Ids(+el))
					: this.styleDescriptions.selected.map((el) => new Ids(el.displayId)),
			collectionIds:
				params && params['collections']
					? params['collections'].split('-').map((el) => new Ids(+el))
					: this.collections.selected.map((el) => new Ids(el.displayId)),
			purposeIds:
				params && params['purposes'] ? params['purposes'].split('-').map((el) => new Ids(+el)) : this.purposes.selected.map((el) => new Ids(el.displayId)),
			teamIds: params && params['teams'] ? params['teams'].split('-').map((el) => new Ids(+el)) : this.teams.selected.map((el) => new Ids(el.displayId)),
			suggestedSeasonIds:
				params && params['shopSellingPeriods']
					? params['shopSellingPeriods'].split('-').map((el) => new Ids(+el))
					: this.shopSellingPeriods.selected.map((el) => new Ids(el.displayId))
		};

		this.#loaderService.showLoader(this.loaderId);
		this.#graphQLService
			.getData<CompanyStyle>(DatabaseQueries.GET_COMPANY_STYLES, filters)
			.pipe(
				takeUntilDestroyed(this.#destroyRef),
				map((res) => res['data']['companyStyles'])
			)
			.subscribe({
				next: (data: WrapperResultGraphQL<any>) => {
					this.database.data = data.nodes[0].datasource;
			 
					this.database.total = data.nodes[0].total;
					this.#loaderService.dismissLoader(this.loaderId);
				},
				error: () => {
					this.#loaderService.dismissLoader(this.loaderId);
				}
			});
	}

	applyFilters(filter: string, selected: Array<any>) {
		if (!selected.length) {
			// Rimozione il parametro dall'url
			this.#filterService.removeDataFromUrl(filter, () => null);
		} else {
			this[filter].selected = selected;
			const ids = selected.map((el) => `${el.displayId}`).join('-');
			this.#filterService.setQueryParams({ [filter]: ids });
		}
	}

	private getBrands(brandIds: Array<number>) {
		const filters = { first: 50, after: null, search: '', brandIds, companyId: this.#appService.companyId };
		this.#graphQLService
			.getData<Brand>(SharedQueries.GET_BRANDS, filters)
			.pipe(
				takeUntilDestroyed(this.#destroyRef),
				map((res) => res['data']['brands'])
			)
			.subscribe((data: WrapperResultGraphQL<any>) => {
				this['brands'].selected = data.nodes.map((el) => ({
					brandId: el.brandId,
					brandName: el.brand.name,
					hasSizeGroup: el.hasSizeGroup,
					displayId: el.brandId!,
					displayName: el.brand.name,
					disabled: false,
					selected: false
				}));
				this.categories.variables.brandIds = this['brands'].selected.map((el) => el.brandId);
			});
	}

	private getCategories(categoryIds: Array<number>) {
		const filters = { first: 50, after: null, search: '', categoryIds };
		this.#graphQLService
			.getData<Category>(SharedQueries.GET_CATEGORIES_BY_IDS, filters)
			.pipe(
				takeUntilDestroyed(this.#destroyRef),
				map((res) => res['data']['category'])
			)
			.subscribe((data: WrapperResultGraphQL<Category>) => {
				this['categories'].selected = data.nodes.map((el) => ({ ...el, displayId: el.id!, displayName: el.name, disabled: false, selected: true }));
			});
	}

	private getPhotographers(photographerIds: Array<Ids>) {
		const filters = {
			companyId: this.#appService.companyId,
			paginationPage: 0,
			paginationSize: 50,
			search: '',
			statusIds: [],
			photographerIds
		};

		this.#graphQLService
			.getData<Photographer>(PhotographerQueries.GET_PHOTOGRAPHERS, filters)
			.pipe(
				takeUntilDestroyed(this.#destroyRef),
				map((res) => res['data']['photographers'])
			)
			.subscribe((data: WrapperResultGraphQL<Photographer>) => {
				this['photographers'].selected = data.nodes.map((el) => ({
					...el,
					displayId: el.personId!,
					displayName: el.fullName!,
					selected: true,
					disabled: false
				}));
			});
	}

	private getWarehouses(warehouseIds: Array<number>) {
		const filters = { first: 50, after: null, search: '', warehouseIds, companyId: this.#appService.companyId };
		this.#graphQLService
			.getData<Warehouse>(DatabaseQueries.GET_WAREHOUSES, filters)
			.pipe(
				takeUntilDestroyed(this.#destroyRef),
				map((res) => res['data']['warehouses'])
			)
			.subscribe((data: WrapperResultGraphQL<Warehouse>) => {
				this['warehouses'].selected = data.nodes.map((w) => ({
					...w,
					fullName: `${w.code.trim()} - ${w.description.trim()}`,
					displayId: w.id!,
					displayName: `${w.code.trim()} - ${w.description.trim()}`,
					disabled: false,
					selected: true
				}));
			});
	}

	private getStyleGroups(styleGroupIds: Array<number>) {
		const filters = { first: 50, after: null, search: '', styleGroupIds };
		this.#graphQLService
			.getData<StyleGroup>(DatabaseQueries.GET_STYLE_GROUPS, filters)
			.pipe(
				takeUntilDestroyed(this.#destroyRef),
				map((res) => res['data']['styleGroups'])
			)
			.subscribe((data: WrapperResultGraphQL<StyleGroup>) => {
				this['styleGroups'].selected = data.nodes.map((el) => ({
					...el,
					displayId: el.id!,
					displayName: el.name,
					disabled: false,
					selected: true
				}));
			});
	}

	private getStyleDescriptions(styleDescriptionIds: Array<number>) {
		const filters = { first: 50, after: null, search: '', styleDescriptionIds };
		this.#graphQLService
			.getData<StyleDescription>(DatabaseQueries.GET_STYLE_DESCRIPTIONS, filters)
			.pipe(
				takeUntilDestroyed(this.#destroyRef),
				map((res) => res['data']['styleDescriptions'])
			)
			.subscribe((data: WrapperResultGraphQL<StyleDescription>) => {
				this['styleDescriptions'].selected = data.nodes.map((el) => ({
					...el,
					displayId: el.id!,
					displayName: el.name,
					disabled: false,
					selected: true
				}));
			});
	}

	private getCollections(collectionIds: Array<number>) {
		const filters = { collectionIds, companyId: this.#appService.companyId };
		this.#graphQLService
			.getData<Collection>(DatabaseQueries.GET_COLLECTIONS, filters)
			.pipe(
				takeUntilDestroyed(this.#destroyRef),
				map((res) => res['data']['collections'])
			)
			.subscribe((data: WrapperResultGraphQL<Collection>) => {
				this['collections'].selected = data.nodes.map((el) => ({
					...el,
					displayId: el.id!,
					displayName: el.name,
					disabled: false,
					selected: true
				}));
			});
	}

	private getPurposes(purposeIds: Array<number>) {
		const filters = { first: 50, after: null, search: '', purposeIds };
		this.#graphQLService
			.getData<Purpose>(DatabaseQueries.GET_PURPOSES, filters)
			.pipe(
				takeUntilDestroyed(this.#destroyRef),
				map((res) => res['data']['purposes'])
			)
			.subscribe((data: WrapperResultGraphQL<Purpose>) => {
				this['purposes'].selected = data.nodes.map((el) => ({
					...el,
					displayId: el.id!,
					displayName: el.name,
					disabled: false,
					selected: true
				}));
			});
	}

	private getTeams(teamIds: Array<number>) {
		const filters = { first: 50, after: null, search: '', teamIds, companyId: this.#appService.companyId };
		this.#graphQLService
			.getData<Team>(DatabaseQueries.GET_TEAMS, filters)
			.pipe(
				takeUntilDestroyed(this.#destroyRef),
				map((res) => res['data']['teams'])
			)
			.subscribe((data: WrapperResultGraphQL<Team>) => {
				this['teams'].selected = data.nodes.map((el) => ({
					...el,
					displayId: el.id!,
					displayName: el.name,
					disabled: false,
					selected: true
				}));
			});
	}

	private getSuggestedSeason(suggestedSeadonIds: Array<number>) {
		const filters = { first: 50, after: null, search: '', seasonIds: suggestedSeadonIds };
		this.#graphQLService
			.getData<SuggestedSeason>(DatabaseQueries.GET_SUGGESTED_SEASONS, filters)
			.pipe(
				takeUntilDestroyed(this.#destroyRef),
				map((res) => res['data']['suggestedSeasons'])
			)
			.subscribe((data: WrapperResultGraphQL<SuggestedSeason>) => {
				this['shopSellingPeriods'].selected = data.nodes.map((el) => ({
					...el,
					displayId: el.id!,
					displayName: el.name,
					disabled: false,
					selected: true
				}));
			});
	}

	// onStyleSidebarInfo(item: CompanyStyle, sidebarTitle: 'Style orders' | 'Style warehouses') {
	// 	item.showMenu = false;
	// 	this.database.tmp = item;
	// 	this.customSidebarTitle = sidebarTitle;
	// 	this.currentSidebar = SidebarTypeEnum.customSidebar;
	// }

	onOrderInfo(item: StyleOrdersInfo) {
		const params: Params = { orderId: item.orderId, orderNumber: item.orderNumber, modelId: item.modelId };
		this.#sidenavService.newItemUrlPart('order-list', params);
	}

	onOrderList() {
		this.#sidenavService.newItemUrlPart('order-list');
	}

	// onExitSidebar() {
	// 	this.currentSidebar = null;
	// 	this.database.tmp = null;
	// }

	// onReshootStyle(item: CompanyStyle) {
	// 	item.showMenu = false;
	// 	this.database.tmp = item;
	// 	this.currentSidebar = SidebarTypeEnum.deleteAction;
	// }

	reshootStyle() {
		this.#graphQLService
			.postData(MutationQuery.RESHOOT_PRODUCT, {
				currentUserId: this.#appService.user.userId,
				companyId: this.#appService.companyId,
				modelId: this.database.tmp.modelId,
				colorId: null,
				sizeGroupId: null
			})
			.pipe(takeUntilDestroyed(this.#destroyRef))
			.subscribe({
				// next: () => this.onExitSidebar(),
				error: (err) => console.error(err)
			});
	}

	private searchTextSubscription() {
		this.#topbarService.searchTextSubscribe.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe({
			next: (data) => {
				if (data !== this.database.search 
					// && !this.modelId
				) {
					this.database.search = data;
					this.getCompanyStyles(0);
				}
			},
			error: (error) => console.error('Error in searchTextSubscription:', error)
		});
	}

	private queryParamsSubscribe() {
		this.#activatedRoute.queryParams.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((data) => {
			// const modelId = data['modelId'];
			// this.modelId = !!modelId ? +modelId : 0;
			this.database.search = '';
			// if (!!this.modelId) {
			// 	this.database.data = [];

			// 	this.brands.selected = [];
			// 	this.categories.selected = [];
			// 	this.warehouses.selected = [];
			// 	this.photographers.selected = [];
			// 	this.styleGroups.selected = [];
			// 	this.styleDescriptions.selected = [];
			// 	this.purposes.selected = [];
			// 	this.teams.selected = [];
			// 	this.shopSellingPeriods.selected = [];
			// } else {
				this.getData();
				this.getCompanyStyles(0, '', data);
			// }
		});
	}

	// private setGridColumns() {
	// 	this.gridColumns = [
	// 		{ title: '', field: '', type: GridColumnTypeEnum.icon, width: 30 },
	// 		{ title: 'Style', field: 'fullName', type: GridColumnTypeEnum.default },
	// 		{ title: 'Brand', field: 'brandName', type: GridColumnTypeEnum.default },
	// 		{ title: 'Category', field: 'categoryName', type: GridColumnTypeEnum.default },
	// 		{ title: 'Warehouses', field: 'warehouses', type: GridColumnTypeEnum.custom },
	// 		{ title: 'Style orders', field: 'ordersInfo', type: GridColumnTypeEnum.custom }
	// 	];
	// 	this.ordersGridColumns = [
	// 		{ title: '', field: '', type: GridColumnTypeEnum.icon, width: 30 },
	// 		{ title: 'Order #', field: 'orderNumber', type: GridColumnTypeEnum.default },
	// 		{ title: 'Photographer', field: 'photographerFullName', type: GridColumnTypeEnum.default }
	// 	];
	// 	this.warehouseGridColumns = [
	// 		{ title: 'Warehouse code', field: 'warehouseCode', type: GridColumnTypeEnum.default },
	// 		{ title: 'Warehouse description', field: 'warehouseDescription', type: GridColumnTypeEnum.default }
	// 	];
	// }
}
